import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { setSelectedAssets, setSelectedLabels, setSelectedNoteDate, setSelectedStakeholders } from '../../../../features/activityNotesSlice';
import { Box } from '@mui/material';
import FilterComponent from '../../../ReusableFIlterComponent/FilterComponent';

const BusinessActivityNotesFilter = ({ clearSelectedNotetitle }: any) => {
  const { filteredActivityNotes, selectedAssets, selectedStakeholders, selectedNoteDate, selectedLabels } = useSelector((state: any) => state?.activityNotes);
  const dispatch = useDispatch();
  const [searchAsset, setSearchAsset] = useState('');
  const [searchStakeHolder, setSearchStakeHolder] = useState('');
  const [searchLabel, setSearchLabel] = useState('');

  const filterConfig = [
      {
        key: 'Related Asset',
        label: 'Select an Related Asset',
        searchTerm: searchAsset,
        onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchAsset(e.target.value),
        selectedOption: selectedAssets,
        filterName: 'website_name',
        data: filteredActivityNotes,
        onSelectionChange: (updatedSelection: any) => dispatch(setSelectedAssets(updatedSelection)),
        count: selectedAssets && selectedAssets?.length,
        colorSelected: selectedAssets !== null && selectedAssets?.length > 0 ? '#9C27B0' : '#000000DE',
        multiSelect: true,
        showSearch: true,
      },
      {
        key: 'stakeholder',
        label: 'Select a stakeholder',
        searchTerm: searchStakeHolder,
        onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchStakeHolder(e.target.value),
        selectedOption: selectedStakeholders,
        filterName: 'note_type',
        data: filteredActivityNotes,
        onSelectionChange: (updatedSelection: any) => dispatch(setSelectedStakeholders(updatedSelection)),
        count: selectedStakeholders && selectedStakeholders?.length,
        colorSelected: selectedStakeholders !== null && selectedStakeholders?.length > 0 ? '#9C27B0' : '#000000DE',
        multiSelect: true,
        showSearch: true,
      },
      {
        key: 'date',
        label: 'Select Date Range',
        filterName: 'created',
        data: filteredActivityNotes,
        selectedOption: selectedNoteDate ,
        onSelectionChange: (updatedSelection: any) => dispatch(setSelectedNoteDate(updatedSelection)),
        count: 0,
        colorSelected: selectedNoteDate !== null && selectedNoteDate?.length > 0 ? '#9C27B0' : '#000000DE',
        multiSelect: false,
        isDateRangeFilter: true
      },{
        key: 'labels',
        label: 'Select a label',
        searchTerm: searchLabel,
        onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchLabel(e.target.value),
        selectedOption: selectedLabels,
        filterName: 'labels',
        data: filteredActivityNotes,
        onSelectionChange: (updatedSelection: any) => dispatch(setSelectedLabels(updatedSelection)),
        count: selectedLabels && selectedLabels?.length,
        colorSelected: selectedLabels !== null && selectedLabels?.length > 0 ? '#9C27B0' : '#000000DE',
        multiSelect: true,
        showSearch: true,
      }
    ];
  
    const clearFilters = () => {
      dispatch(setSelectedAssets(null));
      dispatch(setSelectedStakeholders(null));
      dispatch(setSelectedNoteDate(null));
      dispatch(setSelectedLabels(null))
      clearSelectedNotetitle(null);
      setSearchStakeHolder('');
      setSearchLabel('');
    }

  return (
    <>
      <Box>
        <FilterComponent filterConfig={filterConfig} clearFilters={clearFilters} />
      </Box>
    </>
  )
}

export default BusinessActivityNotesFilter
